import { render, staticRenderFns } from "./PaginationNumber.vue?vue&type=template&id=27403ac4&scoped=true"
import script from "./PaginationNumber.vue?vue&type=script&lang=js"
export * from "./PaginationNumber.vue?vue&type=script&lang=js"
import style0 from "./PaginationNumber.vue?vue&type=style&index=0&id=27403ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27403ac4",
  null
  
)

export default component.exports